import {useGenericFilters} from 'app/hooks';
import {useAsyncActions} from 'app/utils/redux';

import {convertLocationParamsToFetchParams} from './api';
import {selectProcessesFilters, setProcessesFilters} from './slice';

import type {ProcessDashboardFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router';

export function useProcessFilters(
  location: Location<ProcessDashboardFetchParamsType>,
  router: InjectedRouter
) {
  return useGenericFilters(
    location,
    router,
    selectProcessesFilters,
    useAsyncActions({
      setProcessesFilters,
    }).setProcessesFilters,
    convertLocationParamsToFetchParams
  );
}
